<template>
    <section :class="{selection: true, 'selection-slider': slice.variation === 'slider'}">
        <div class="content">
            <PrismicRichText :field="slice.primary.title" class="title" />
            <template v-if="!currentBreakpoints?.isMobile && slice.variation === 'default'">
                <div v-if="!currentBreakpoints?.isMobile && slice.variation === 'default'" class="selection-grid">
                    <SelectionCard v-for="(item, index) in slice.items" :key="`selection-${index}`" :content="item.content" />
                </div>
            </template>
            <template v-else>
                <Swiper
                    slides-per-view="auto"
                    :space-between="24"
                    :breakpoints="{[breakpoints.mobile]: {slidesPerView: 'auto', spaceBetween: 40}}"
                    :modules="MODULES"
                    :navigation="true"
                >
                    <SwiperSlide v-for="(item, index) in slice.items" :key="`selection-${index}`" class="slider-card">
                        <SelectionCard :content="item.content" />
                    </SwiperSlide>
                </Swiper>
            </template>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {inject} from 'vue';
    import {getSliceComponentProps, PrismicRichText} from '@prismicio/vue';
    import type {SelectionSlice} from '@prismicio-types';
    // @ts-expect-error - swiper has no types
    import {Navigation} from 'swiper';
    import {Swiper, SwiperSlide} from 'swiper/vue';
    import {useRuntimeConfig} from '#imports';
    import {MEDIA_BREAKPOINTS} from '~/app/keys';
    import SelectionCard from '~/components/SelectionCard.vue';

    const currentBreakpoints = inject(MEDIA_BREAKPOINTS);
    const MODULES = [Navigation];
    const {breakpoints} = useRuntimeConfig().public;
    defineProps({
        ...getSliceComponentProps<SelectionSlice>(),
    });
</script>

<style lang="scss">
    @use '~/assets/styles/variables' as *;

    .selection {
        position: relative;
        padding: 150px 0;

        @media (max-width: $mobile-breakpoint) {
            padding: 80px 0;
        }

        .slider-card {
            max-width: 400px;

            @media (max-width: $mobile-breakpoint) {
                max-width: 250px;
            }
        }

        .selection-grid {
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            gap: var(--joy-core-spacing-9);
            justify-items: stretch;

            @media (max-width: $mobile-breakpoint) {
                grid-template-columns: 1fr;
            }
        }

        .content {
            @include content-width;

            .title {
                margin-bottom: var(--joy-core-spacing-9);
            }

            .swiper-button-prev,
            .swiper-button-next {
                display: none;
            }
        }

        &.selection-slider {
            overflow: hidden;
            position: relative;

            .swiper {
                overflow: visible;
                margin-right: 40px;
                padding-bottom: 60px;

                @media (max-width: $mobile-breakpoint) {
                    margin-right: 0;
                }
            }

            .swiper-wrapper {
                overflow: visible;
            }

            .slide {
                width: auto;
                max-width: 400px;

                @media (max-width: $mobile-breakpoint) {
                    width: 100%;
                }
            }

            .swiper-button-prev,
            .swiper-button-next {
                content: url('~/assets/svg/arrowRight.svg');
                display: block;
                padding: var(--joy-core-spacing-3);
                border-radius: var(--joy-core-radius-6);
                height: 42px;
                width: 42px;
                background-color: var(--joy-color-primary-50);
                position: absolute;
                top: unset;
                bottom: 10px;
                left: unset;
                right: 0;
            }

            .swiper-button-prev {
                transform: rotate(180deg);
                left: unset;
                right: 60px;
            }
        }
    }
</style>
